"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.saveBrandingEpic = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var fetchCompanyInfoEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getCompanyInfo,
  sc404isSuccess: true,
  initiatingActionType: _actions.BrandingActionTypes.FETCH_COMPANY_INFO,
  requestActions: _actions.FetchCompanyInfo,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.BrandingActionTypes.FETCH_COMPANY_INFO)
}));
var fetchBrandingEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getBranding,
  initiatingActionType: _actions.BrandingActionTypes.FETCH_BRANDING,
  requestActions: _actions.FetchBranding,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.BrandingActionTypes.FETCH_BRANDING)
}));
var saveBrandingEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createOrUpdateBranding,
  initiatingActionType: _actions.BrandingActionTypes.SAVE_BRANDING,
  requestActions: _actions.SaveBranding,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.BrandingActionTypes.SAVE_BRANDING)
}));
exports.saveBrandingEpic = saveBrandingEpic;

var _default = (0, _reduxObservable.combineEpics)(fetchCompanyInfoEntity, fetchBrandingEntity);

exports.default = _default;